var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { updateUserPreferencesForCurrentUser as updateUserPreferencesForCurrentUserPlatform, } from 'src/platform/entities/user_preferences/user_preferences';
/**
 * Updates a specific preference value for the current user in platform.
 * @param preferenceKeyPath The path to the preference key to update.
 * @param preferenceValue The new value to set.
 */
export function updateUserPreferencesForCurrentUser_platform(preferenceKeyPath, preferenceValue) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield updateUserPreferencesForCurrentUserPlatform({
            namespace: 'platform',
            preferenceKeyPath,
            preferenceValue,
        });
        return response;
    });
}
